import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { useStore } from '../../../store/store';
import { PROFILER_SEARCH_FIELDS } from '../../../utils/constants/fields';
import {
  isProfilerAdvancedCriteriaDisabled,
  isProfilerAdvancedCriteriaOwnershipDisabled
} from '../../../utils/constants/variables';

const OWNERSHIP_FIELDS = [
  PROFILER_SEARCH_FIELDS.LISTING_STATUS,
  PROFILER_SEARCH_FIELDS.OWNERSHIP_STRUCTURES,
  PROFILER_SEARCH_FIELDS.OWNERSHIP_BASIS
];

/**
 * The ownership criteria of a saved search, read-only, as one `.group` row of the
 * criteria panels on saved projects and feedback requests: Ownership, Ownership structure and
 * Ownership chain position. Characteristics and Industries use the same field NAMEs. Searches
 * saved before the ownership criteria existed carry no ownership keys: empty values.
 */
const OwnershipCriteriaGroup = observer(({ fields = {} }) => {
  const { utilsStore } = useStore();
  if (isProfilerAdvancedCriteriaDisabled || isProfilerAdvancedCriteriaOwnershipDisabled) {
    return null;
  }

  return (
    <div className="group">
      {OWNERSHIP_FIELDS.map((field) => (
        <div className="field" key={field.NAME}>
          <div className="label">{field.LABEL}</div>
          <div className="value">
            {fields[field.NAME]?.length ? utilsStore.getOptionName(fields, field).join(', ') : ''}
          </div>
        </div>
      ))}
    </div>
  );
});

OwnershipCriteriaGroup.propTypes = {
  fields: PropTypes.object
};

export default OwnershipCriteriaGroup;
